import React from "react";
import "./Payment.scss";
import {Razorpay_Key} from "../../serviceApi";
import {AddOrderData} from "../../Actions/index";
import {compose} from "redux";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';


class Payment extends React.Component{

    componentDidMount(){
        if(Object.keys(this.props.order_data).length > 0 ){
            this.processPayment();
        } else {
            this.props.history.push('/home');
        }
    }

    processPayment  = () => {
        let data = this.props.order_data;

        let scope = this;
        var options = {
            "key": Razorpay_Key, // Enter the Key ID generated from the Dashboard
            "amount": data.order_total, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise or INR 500.
            "currency": "INR",
            "name": "Neta",
            "image": "https://app.neta.co.in/CoreIcon.png",
            "order_id": data.razorpayOrderId,//This is a sample Order ID. Create an Order using Orders API. (https://razorpay.com/docs/payment-gateway/orders/integration/#step-1-create-an-order). Refer the Checkout form table given below
            "handler": function (response,err){
                scope.sendPaymentResponse(data,response);
            },
            "prefill": {
                "name": data.user.username,
                "email": data.user.email,
                "contact": data.user.mobileNumber
            },
            "notes": {
                "address": ""
            },
            "theme": {
                "color": "#000"
            }
        };
        const rzp1 = new window.Razorpay(options);
        // rzp1.on('payment.failed', function (response){
        //     alert(response.error.code);
        //     alert(response.error.description);
        //     alert(response.error.source);
        //     alert(response.error.step);
        //     alert(response.error.reason);
        //     alert(response.error.metadata.order_id);
        //     alert(response.error.metadata.payment_id);
        // });
        rzp1.open();

    };

    sendPaymentResponse = () => {
        this.props.sendOrderDatasToStore({});
        this.props.history.push('/wallet');
    };

    render(){
        return(
            <div>
                <div className="order-confirmation">
                    <h3>
                        Make Payment <br /> To Complete Your Order
                    </h3>
                    <div className="order-confirmation__actions">
                        <button type="button" className=" btn btn-primary continue_shopping_btn" onClick={this.processPayment}><span>Make Payment</span></button>
                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => ({
    order_data: state.OrderReducer.order_data,
});

const mapDispatchToProps = dispatch => ({
    sendOrderDatasToStore: order_data => dispatch(AddOrderData(order_data)),
});


export default compose(
    withRouter,
    connect(mapStateToProps,mapDispatchToProps)
)(Payment);
